import React from 'react';
import { connect } from "react-redux";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import StaticHtmlContent from "../../common/staticHtmlContent";

class TermsForShareLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shareLinkTerms: props.videoVisitShareLinkTerms.termsList,
            heading: "",
            isTermsSelectionError: false
        };
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.VideoVisit.TermsForShareLink.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    onDocsSelectionChange = (e, index) => {
        if (e.target) {
            const terms = this.state.shareLinkTerms;
            terms[index].isAccepted = e.target.checked ? true : false;
            this.setState({
                shareLinkTerms: terms
            }, () => {
                let isAcknowledged = true;
                for (let j = 0; j < terms.length; j++) {
                    if (!terms[j].isAccepted) {
                        isAcknowledged = false;
                        break;
                    }
                }
                if (isAcknowledged) {
                    if (this.state.isTermsSelectionError) {
                       this.setState({
                           isTermsSelectionError: false
                       });
                    }
                }
            });
        }
    }

    onSubmit() {
        const { shareLinkTerms } = this.state;
        const { acceptTerms } = this.props;
        let isAcknowledged = true;
        for (let j = 0; j < shareLinkTerms.length; j++) {
            if (!shareLinkTerms[j].isAccepted) {
                isAcknowledged = false;
                break;
            }
        }
        if (isAcknowledged) {
            acceptTerms(shareLinkTerms);
        } else {
            this.setState({
                isTermsSelectionError: true
            });
        }
    }

    render() {
        const { videoVisitShareLinkTerms, style } = this.props;
        const { isTermsSelectionError, shareLinkTerms } = this.state;

        const terms = videoVisitShareLinkTerms && videoVisitShareLinkTerms.termsList ? videoVisitShareLinkTerms.termsList.map((term, index) =>
            <div className="col-12" key={"ShareLinkTerms" + '_' + term.id + '_' + term.featureId}>
                <label className="checkbox-container">
                    <input
                        type="checkbox"
                        name={"ShareLinkTerms" + '_' + term.id}
                        checked={shareLinkTerms[index].isAccepted}
                        onChange={(e) => this.onDocsSelectionChange(e, index)}
                    />
                    <span className="checkmark" />
                    <span className="checkbox-label"><StaticHtmlContent content={term.textToDisplay} /></span>
                </label>
            </div>
        ) : <div></div>;
        
        return (
                <div className="agree-to-terms-container sm-width-step" style={style}>
                    <div className="row">
                        <div className="col-12">
                            <h1 className="step-heading step-heading-md">The legal docs</h1>
                        </div>
                        <div className="col-12 step-form-container">
                            <div className="row legal-docs-container">
                                    {terms}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="footer-buttons">
                                {isTermsSelectionError &&
                                    <div className="error-msg">Please agree to terms.</div>
                                }
                                <button className={`btn btn-primary`}
                                    onClick={this.onSubmit}>
                                    AGREE AND JOIN VISIT
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsForShareLink);